module.exports = __webpack_public_path__ + "img/logo.3212b769.png";